import { render, staticRenderFns } from "./LanguageInfo.vue?vue&type=template&id=551fe439&"
import script from "./LanguageInfo.vue?vue&type=script&lang=js&"
export * from "./LanguageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports